<app-loader *ngIf="isDisabled || isDisabledG"></app-loader>
<form name="EmployeeDetailForm" #EmployeeDetailForm="ngForm" (ngSubmit)="FinalSubmit()">
    <div class="card">
        <div class="card-body p-0">
            <div class="card">
                <div class="card-header">
                    On Board Details
                </div>
                <div class="card-body p-1">
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.employeeInfo.EmpTempCode!=null,'bghighlightworning': EmployeeDetail.employeeInfo.EmpTempCode==null}">
                            <div class="row">
                                <div class="text-label">Employee Temp Code</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.employeeInfo.EmpTempCode}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.employeeInfo.FirstName!=null,'bghighlightworning': EmployeeDetail.employeeInfo.FirstName==null}">
                            <div class="row">
                                <div class="text-label">First Name</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.employeeInfo.FirstName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.employeeInfo.EmailId!=null,'bghighlightworning': EmployeeDetail.employeeInfo.EmailId==null}">
                            <div class="row">
                                <div class="text-label">Email ID</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.employeeInfo.EmailId}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.employeeInfo.MobileNo!=null,'bghighlightworning': EmployeeDetail.employeeInfo.MobileNo==null}">
                            <div class="row">
                                <div class="text-label">Mobile No</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.employeeInfo.MobileNo}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.employeeInfo.RegistrationType!=null,'bghighlightworning': EmployeeDetail.employeeInfo.RegistrationType==null}">
                            <div class="row">
                                <div class="text-label">Registration Type</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.employeeInfo.RegistrationType}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.employeeInfo.EmpType!=null,'bghighlightworning': EmployeeDetail.employeeInfo.EmpType==null}">
                            <div class="row">
                                <div class="text-label">Employee Type</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.employeeInfo.EmpType}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-4 px-1">
                            <div class="card">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col">
                                            Aadhaar Card
                                        </div>
                                        <div class="col-auto me-1">
                                            <span class="badge verify" [ngClass]="{
                                                    'bg-success': common.ToLowerCase(EmployeeDetail.Verification.AadharVerificationStatus) === 'verified',
                                                    'bg-warning': common.ToLowerCase(EmployeeDetail.Verification.AadharVerificationStatus) !== 'verified',
                                                }">
                                                <i
                                                    class="bi bi-{{common.ToLowerCase(EmployeeDetail.Verification.AadharVerificationStatus) === 'verified' ? 'check-circle' : 'exclamation-circle'}}"></i>
                                                {{EmployeeDetail.Verification.AadharVerificationStatus}}
                                            </span>
                                        </div>
                                        <div class="col-auto">
                                            <div class="col-auto"
                                                *ngIf="EmployeeDetail.Verification.AadharAttachment != '' && EmployeeDetail.Verification.AadharAttachment != null">
                                                <a [href]="EmployeeDetail.Verification.AadharAttachmenturl"
                                                    target="_blank">
                                                    <span class="badge verify success">
                                                        <i class="bi bi-paperclip"></i> View
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-0">
                                    <div class="col-md-12 mb-1"
                                        [ngClass]="{'bghighlight': EmployeeDetail.Verification.NameAsPerAadhaar!=null,'bghighlightworning': EmployeeDetail.Verification.NameAsPerAadhaar==null}">
                                        <div class="row">
                                            <div class="text-label">Name as Per Aadhaar</div>
                                        </div>
                                        <div class="row text-right">
                                            <div>{{EmployeeDetail.Verification.NameAsPerAadhaar}}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mb-1"
                                        [ngClass]="{'bghighlight': EmployeeDetail.Verification.AadharNo!=null,'bghighlightworning': EmployeeDetail.Verification.AadharNo==null}">
                                        <div class="row">
                                            <div class="text-label">Aadhaar No</div>
                                        </div>
                                        <div class="row text-right">
                                            <div>{{EmployeeDetail.Verification.AadharNo}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 px-1">
                            <div class="card">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col">
                                            Pan Card
                                        </div>
                                        <div class="col-auto me-1">
                                            <span class="badge verify"
                                                [ngClass]="{'bg-success': common.ToLowerCase(EmployeeDetail.Verification.PANVerificationStatus) === 'verified', 'bg-warning': common.ToLowerCase(EmployeeDetail.Verification.PANVerificationStatus) !== 'verified'}">
                                                <i
                                                    class="bi bi-{{common.ToLowerCase(EmployeeDetail.Verification.PANVerificationStatus) === 'verified' ? 'check-circle' : 'exclamation-circle'}}"></i>
                                                {{EmployeeDetail.Verification.PANVerificationStatus}}
                                            </span>
                                        </div>
                                        <div class="col-auto"
                                            *ngIf="EmployeeDetail.Verification.PANAttachment != '' && EmployeeDetail.Verification.PANAttachment != null">
                                            <a [href]="EmployeeDetail.Verification.PANAttachmenturl" target="_blank">
                                                <span class="badge verify success">
                                                    <i class="bi bi-paperclip"></i> View
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-0">
                                    <div class="col-md-12 mb-1"
                                        [ngClass]="{'bghighlight': EmployeeDetail.Verification.NameAsPerPAN!=null,'bghighlightworning': EmployeeDetail.Verification.NameAsPerPAN==null}">
                                        <div class="row">
                                            <div class="text-label">Name As Per PAN</div>
                                        </div>
                                        <div class="row text-right">
                                            <div>{{EmployeeDetail.Verification.NameAsPerPAN}}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mb-1"
                                        [ngClass]="{'bghighlight': EmployeeDetail.Verification.PANNo!=null,'bghighlightworning': EmployeeDetail.Verification.PANNo==null}">
                                        <div class="row">
                                            <div class="text-label">PAN No</div>
                                        </div>
                                        <div class="row text-right">
                                            <div>{{EmployeeDetail.Verification.PANNo}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 px-1">
                            <div class="card">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col">
                                            Bank Detail
                                        </div>
                                        <div class="col-auto me-1">
                                            <span class="badge verify"
                                                [ngClass]="{'bg-success': common.ToLowerCase(EmployeeDetail.Verification.BankVerificationStatus) === 'verified', 'bg-warning': common.ToLowerCase(EmployeeDetail.Verification.BankVerificationStatus) !== 'verified'}">
                                                <i
                                                    class="bi bi-{{common.ToLowerCase(EmployeeDetail.Verification.BankVerificationStatus) === 'verified' ? 'check-circle' : 'exclamation-circle'}}"></i>
                                                {{EmployeeDetail.Verification.BankVerificationStatus}}
                                            </span>
                                        </div>
                                        <div class="col-auto"
                                            *ngIf="EmployeeDetail.Verification.BankAttachment != '' && EmployeeDetail.Verification.BankAttachment != null">
                                            <a [href]="EmployeeDetail.Verification.BankAttachmenturl" target="_blank">
                                                <span class="badge verify success">
                                                    <i class="bi bi-paperclip"></i> View
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-0">
                                    <div class="col-md-12 mb-1"
                                        [ngClass]="{'bghighlight': EmployeeDetail.Verification.PaymentMode!=null,'bghighlightworning': EmployeeDetail.Verification.PaymentMode==null}">
                                        <div class="row">
                                            <div class="text-label">Payment Mode</div>
                                        </div>
                                        <div class="row text-right">
                                            <div>{{EmployeeDetail.Verification.PaymentMode}}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mb-1"
                                        [ngClass]="{'bghighlight': EmployeeDetail.Verification.NameAsPerBank!=null,'bghighlightworning': EmployeeDetail.Verification.NameAsPerBank==null}">
                                        <div class="row">
                                            <div class="text-label">Name As Per Bank</div>
                                        </div>
                                        <div class="row text-right">
                                            <div>{{EmployeeDetail.Verification.NameAsPerBank}}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mb-1"
                                        [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.BankName!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.BankName==null}">
                                        <div class="row">
                                            <div class="text-label">Bank Name</div>
                                        </div>
                                        <div class="row text-right">
                                            <div>{{EmployeeDetail.AccountLicencesTab.BankName}}</div>
                                        </div>
                                    </div>
                                    <div class="col-md mb-1"
                                        [ngClass]="{'bghighlight': EmployeeDetail.Verification.BankAccountNo!=null,'bghighlightworning': EmployeeDetail.Verification.BankAccountNo==null}">
                                        <div class="row">
                                            <div class="text-label">Bank Account No</div>
                                        </div>
                                        <div class="row text-right">
                                            <div>{{EmployeeDetail.Verification.BankAccountNo}}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 ms-1 mb-1"
                                        [ngClass]="{'bghighlight': EmployeeDetail.Verification.IFSCode!=null,'bghighlightworning': EmployeeDetail.Verification.IFSCode==null}">
                                        <div class="row">
                                            <div class="text-label">IFSCode</div>
                                        </div>
                                        <div class="row text-right">
                                            <div>{{EmployeeDetail.Verification.IFSCode}}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mb-1"
                                        [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.ReferenceNumber!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.ReferenceNumber==null}">
                                        <div class="row">
                                            <div class="text-label">Reference No</div>
                                        </div>
                                        <div class="row text-right">
                                            <div>{{EmployeeDetail.AccountLicencesTab.ReferenceNumber}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    On Board Details
                </div>
                <div class="card-body p-1">
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.Verification.PaymentMode!=null,'bghighlightworning': EmployeeDetail.Verification.PaymentMode==null}">
                            <div class="row">
                                <div class="text-label">Employee Code</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.BasicInformation.EmpCode}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.OldEmpCode!=null,'bghighlightworning': EmployeeDetail.BasicInformation.OldEmpCode==null}">
                            <div class="row">
                                <div class="text-label">Old Employee Code</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.BasicInformation.OldEmpCode}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.BranchName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.BranchName==null}">
                            <div class="row">
                                <div class="text-label">Branch Name</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.BasicInformation.BranchName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.RegistrationDate!=null,'bghighlightworning': EmployeeDetail.BasicInformation.RegistrationDate==null}">
                            <div class="row">
                                <div class="text-label">Registration Date</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.BasicInformation.RegistrationDate}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.JoiningDate!=null,'bghighlightworning': EmployeeDetail.BasicInformation.JoiningDate==null}">
                            <div class="row">
                                <div class="text-label">Joining Date</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.BasicInformation.JoiningDate}}</div>
                            </div>
                        </div>
                        <!-- <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.ProbationDate!=null,'bghighlightworning': EmployeeDetail.BasicInformation.ProbationDate==null}">
                            <div class="row">
                                <div class="text-label">Probation Date</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.BasicInformation.ProbationDate}}</div>
                            </div>
                        </div> -->
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <img mat-card-image class="registrationImage" height="80%" width="110%"
                                [src]="EmployeeDetail.BasicInformation.photourl"
                                *ngIf="EmployeeDetail.BasicInformation.photo != null && EmployeeDetail.BasicInformation.photo != ''">
                        </div>
                        <div class="col-md-10">
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.NameAsPerAadhar!=null,'bghighlightworning': EmployeeDetail.BasicInformation.NameAsPerAadhar==null}">
                                    <div class="row">
                                        <div class="text-label">Name As Per Aadhaar</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.NameAsPerAadhar}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.firstName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.firstName==null}">
                                    <div class="row">
                                        <div class="text-label">First Name</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.firstName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.middleName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.middleName==null}">
                                    <div class="row">
                                        <div class="text-label">Middle Name</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.middleName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.lastName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.lastName==null}">
                                    <div class="row">
                                        <div class="text-label">Last Name</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.lastName}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.GenderName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.GenderName==null}">
                                    <div class="row">
                                        <div class="text-label">Gender</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.GenderName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.BirthDate!=null,'bghighlightworning': EmployeeDetail.BasicInformation.BirthDate==null}">
                                    <div class="row">
                                        <div class="text-label">Birth Date</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.BirthDate}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.PreviousName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.PreviousName==null}">
                                    <div class="row">
                                        <div class="text-label">Previous Name</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.PreviousName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.FatherName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.FatherName==null}">
                                    <div class="row">
                                        <div class="text-label">Father Name</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.FatherName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.MotherName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.MotherName==null}">
                                    <div class="row">
                                        <div class="text-label">MotherName</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.MotherName}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.CasteName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.CasteName==null}">
                                    <div class="row">
                                        <div class="text-label">Caste Name</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.CasteName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.ReligionName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.ReligionName==null}">
                                    <div class="row">
                                        <div class="text-label">Religion Name</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.ReligionName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.NationalityName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.NationalityName==null}">
                                    <div class="row">
                                        <div class="text-label">Nationality Name</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.NationalityName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.MotherTongueName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.MotherTongueName==null}">
                                    <div class="row">
                                        <div class="text-label">Mother Tongue</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.MotherTongueName}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.ContactNo1!=null,'bghighlightworning': EmployeeDetail.BasicInformation.ContactNo1==null}">
                                    <div class="row">
                                        <div class="col">
                                            <div class="text-label">Contact No 1</div>
                                        </div>
                                        <div class="col-auto me-1">
                                            <span class="badge verify" [ngClass]="{
                                                    'bg-success': common.ToLowerCase(EmployeeDetail.Verification.MobileVerificationStatus) === 'verified',
                                                    'bg-warning': common.ToLowerCase(EmployeeDetail.Verification.MobileVerificationStatus) !== 'verified',
                                                }">
                                                <i
                                                    class="bi bi-{{common.ToLowerCase(EmployeeDetail.Verification.MobileVerificationStatus) === 'verified' ? 'check-circle' : 'exclamation-circle'}}"></i>
                                                {{EmployeeDetail.Verification.MobileVerificationStatus}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.employeeInfo.MobileNo}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.ContactNo2!=null,'bghighlightworning': EmployeeDetail.BasicInformation.ContactNo2==null}">
                                    <div class="row">
                                        <div class="text-label">Contact No 2</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.ContactNo2}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.PersonalEmail!=null,'bghighlightworning': EmployeeDetail.BasicInformation.PersonalEmail==null}">
                                    <div class="row">
                                        <div class="col">
                                            <div class="text-label">Personal Email</div>
                                        </div>
                                        <div class="col-auto me-1">
                                            <span class="badge verify" [ngClass]="{
                                                    'bg-success': common.ToLowerCase(EmployeeDetail.Verification.EmailVerificationStatus) === 'verified',
                                                    'bg-warning': common.ToLowerCase(EmployeeDetail.Verification.EmailVerificationStatus) !== 'verified',
                                                }">
                                                <i
                                                    class="bi bi-{{common.ToLowerCase(EmployeeDetail.Verification.EmailVerificationStatus) === 'verified' ? 'check-circle' : 'exclamation-circle'}}"></i>
                                                {{EmployeeDetail.Verification.EmailVerificationStatus}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.PersonalEmail}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.OfficialEmail!=null,'bghighlightworning': EmployeeDetail.BasicInformation.OfficialEmail==null}">
                                    <div class="row">
                                        <div class="text-label">Official Email</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.OfficialEmail}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.MonthlySalaryExpected!=null,'bghighlightworning': EmployeeDetail.BasicInformation.MonthlySalaryExpected==null}">
                                    <div class="row">
                                        <div class="text-label">Monthly Salary Expected</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.MonthlySalaryExpected}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.GradeName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.GradeName==null}">
                                    <div class="row">
                                        <div class="text-label">Grade Name</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.GradeName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.DepartmentName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.DepartmentName==null}">
                                    <div class="row">
                                        <div class="text-label">Department Name</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.DepartmentName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.SalaryStructureName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.SalaryStructureName==null}">
                                    <div class="row">
                                        <div class="text-label">Salary Structure Name</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.SalaryStructureName}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.ContractStartDate!=null,'bghighlightworning': EmployeeDetail.BasicInformation.ContractStartDate==null}">
                                    <div class="row">
                                        <div class="text-label">Contract Start Date</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.ContractStartDate}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.ContractEndDate!=null,'bghighlightworning': EmployeeDetail.BasicInformation.ContractEndDate==null}">
                                    <div class="row">
                                        <div class="text-label">Contract End Date</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.ContractEndDate}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1 bghighlight">
                                    <div class="row">
                                        <div class="text-label">Smart Phone User?</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.IsSmartPhoneUser?'Yes':'No'}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"></div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.ReportingManager1!=null,'bghighlightworning': EmployeeDetail.BasicInformation.ReportingManager1==null}">
                                    <div class="row">
                                        <div class="text-label">Reporting Manager 1</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.ReportingManager1}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.ReportingManager2!=null,'bghighlightworning': EmployeeDetail.BasicInformation.ReportingManager2==null}">
                                    <div class="row">
                                        <div class="text-label">Reporting Manager 2</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.ReportingManager2}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.EmpServiceTypeCode!=null,'bghighlightworning': EmployeeDetail.BasicInformation.EmpServiceTypeCode==null}">
                                    <div class="row">
                                        <div class="text-label">Service Type</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.EmpServiceTypeCode}} -
                                            {{EmployeeDetail.BasicInformation.EmployeeServiceTypeName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.RelieverFlag!=null,'bghighlightworning': EmployeeDetail.BasicInformation.RelieverFlag==null}">
                                    <div class="row">
                                        <div class="text-label">Is Reliever</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.RelieverFlag?'Yes':'No'}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.OldERPDesignation!=null,'bghighlightworning': EmployeeDetail.BasicInformation.OldERPDesignation==null}">
                                    <div class="row">
                                        <div class="text-label">Old ERP Designation</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.OldERPDesignation}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.ClientEmpCode!=null,'bghighlightworning': EmployeeDetail.BasicInformation.ClientEmpCode==null}">
                                    <div class="row">
                                        <div class="text-label">Client Emp Code</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.ClientEmpCode}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.BillabilityStatus!=null,'bghighlightworning': EmployeeDetail.BasicInformation.BillabilityStatus==null}">
                                    <div class="row">
                                        <div class="text-label">Billability Status</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmployeeDetail.BasicInformation.BillabilityStatus}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Posting Order
                </div>
                <div class="card-body p-1">
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.PresentStatus!=null,'bghighlightworning': EmployeeDetail.BasicInformation.PresentStatus==null}">
                            <div class="row">
                                <div class="text-label">Present Status</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.BasicInformation.PresentStatus}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.StatusDate!=null,'bghighlightworning': EmployeeDetail.BasicInformation.StatusDate==null}">
                            <div class="row">
                                <div class="text-label">Status Date</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.BasicInformation.StatusDate}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.ClientGroupName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.ClientGroupName==null}"
                            *ngIf="common.ToLowerCase(EmployeeDetail.employeeInfo.EmpType) == 'front'">
                            <div class="row">
                                <div class="text-label">Client</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.BasicInformation.ClientGroupName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.SiteName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.SiteName==null}"
                            *ngIf="common.ToLowerCase(EmployeeDetail.employeeInfo.EmpType) == 'front'">
                            <div class="row">
                                <div class="text-label">Site</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.BasicInformation.SiteName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.DesignationName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.DesignationName==null}">
                            <div class="row">
                                <div class="text-label">Designation</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.BasicInformation.DesignationName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.DutyName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.DutyName==null}"
                            *ngIf="common.ToLowerCase(EmployeeDetail.employeeInfo.EmpType) == 'front'">
                            <div class="row">
                                <div class="text-label">Duty</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.BasicInformation.DutyName}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.EmpServiceTypeName!=null,'bghighlightworning': EmployeeDetail.BasicInformation.EmpServiceTypeName==null}">
                            <div class="row">
                                <div class="text-label">Emp Service Type</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.BasicInformation.EmpServiceTypeName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.BasicInformation.ShiftTitle!=null,'bghighlightworning': EmployeeDetail.BasicInformation.ShiftTitle==null}">
                            <div class="row">
                                <div class="text-label">Shift</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.BasicInformation.ShiftTitle}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Additional Information
                </div>
                <div class="card-body p-1">
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.IdenficationMark1!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.IdenficationMark1==null}">
                            <div class="row">
                                <div class="text-label">IdenficationMark 1</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.IdenficationMark1}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.IdenficationMark2!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.IdenficationMark2==null}">
                            <div class="row">
                                <div class="text-label">IdenficationMark 2</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.IdenficationMark2}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.PhysicalDisability!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.PhysicalDisability==null}">
                            <div class="row">
                                <div class="text-label">Physical Disability</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.PhysicalDisability}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.BloodGroupName!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.BloodGroupName==null}">
                            <div class="row">
                                <div class="text-label">Blood Group</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.BloodGroupName}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.ChestSize!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.ChestSize==null}">
                            <div class="row">
                                <div class="text-label">Chest Size</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.ChestSize}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.Height!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.Height==null}">
                            <div class="row">
                                <div class="text-label">Height</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.Height}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.Weight!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.Weight==null}">
                            <div class="row">
                                <div class="text-label">Weight</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.Weight}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.ColourofEyes_Name!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.ColourofEyes_Name==null}">
                            <div class="row">
                                <div class="text-label">Colour of Eyes</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.ColourofEyes_Name}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.ColourofHair_Name!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.ColourofHair_Name==null}">
                            <div class="row">
                                <div class="text-label">Colour of Hair</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.ColourofHair_Name}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.UniformSizeName!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.UniformSizeName==null}">
                            <div class="row">
                                <div class="text-label">Uniform Size</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.UniformSizeName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.ShoesSizeName!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.ShoesSizeName==null}">
                            <div class="row">
                                <div class="text-label">Shoes Size</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.ShoesSizeName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.MaritalStatusName!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.MaritalStatusName==null}">
                            <div class="row">
                                <div class="text-label">Marital Status</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.MaritalStatusName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.NoofChildren!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.NoofChildren==null}">
                            <div class="row">
                                <div class="text-label">No of Children</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.NoofChildren}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.NoofDependents!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.NoofDependents==null}">
                            <div class="row">
                                <div class="text-label">No of Dependent</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.NoofDependents}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.SpouseName!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.SpouseName==null}">
                            <div class="row">
                                <div class="text-label">Spouse Name</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.SpouseName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.SpouseBirthDate!=null,'bghighlightworning': EmployeeDetail.AdditionalInformation.SpouseBirthDate==null}">
                            <div class="row">
                                <div class="text-label">Spouse Birth Date</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.SpouseBirthDate}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Metro City</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.MetroCity?'Yes':'No'}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">AutoTDS</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AdditionalInformation.AutoTDS?'Yes':'No'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            Qualification Details
                        </div>
                        <div class="col-auto"
                            *ngIf="EmployeeDetail.AdditionalInformation.DegreeAttachment != '' && EmployeeDetail.AdditionalInformation.DegreeAttachment != null">
                            <a [href]="EmployeeDetail.AdditionalInformation.DegreeAttachmenturl" target="_blank">
                                <span class="badge verify success">
                                    <i class="bi bi-paperclip"></i> Degree
                                </span>
                            </a>
                        </div>
                        <div class="col-auto"
                            *ngIf="EmployeeDetail.AdditionalInformation.QualificationAttachment != '' && EmployeeDetail.AdditionalInformation.QualificationAttachment != null">
                            <a [href]="EmployeeDetail.AdditionalInformation.QualificationAttachmenturl" target="_blank">
                                <span class="badge verify success">
                                    <i class="bi bi-paperclip"></i> View
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="card-body p-1">
                    <div class="row m-1"
                        [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.Ess_Qual.length>0,'bghighlightworning': EmployeeDetail.AdditionalInformation.Ess_Qual.length == 0}">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col" style="background-color: lightgray;">#</th>
                                    <th scope="col" style="background-color: lightgray;">Grade Class</th>
                                    <th scope="col" style="background-color: lightgray;">Percentage</th>
                                    <th scope="col" style="background-color: lightgray;">Qualification Name</th>
                                    <th scope="col" style="background-color: lightgray;">University Board</th>
                                    <th scope="col" style="background-color: lightgray;">Year Of Passing</th>
                                    <th scope="col" style="background-color: lightgray;">Enrollment Number</th>
                                    <th scope="col" style="background-color: lightgray;">College</th>
                                    <th scope="col" style="background-color: lightgray;">CGPA</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="let Ess_Qual of EmployeeDetail.AdditionalInformation.Ess_Qual; let i = index">
                                    <th scope="row">{{ i + 1 }}</th>
                                    <td>{{ Ess_Qual.GradeClass }}</td>
                                    <td>{{ Ess_Qual.Percentage }}</td>
                                    <td>{{ Ess_Qual.QualificationName }}</td>
                                    <td>{{ Ess_Qual.UniversityBoard }}</td>
                                    <td>{{Ess_Qual.YearOfPassing}}</td>
                                    <td>{{Ess_Qual.EnrollmentNumber}}</td>
                                    <td>{{Ess_Qual.College}}</td>
                                    <td class="text-center">{{Ess_Qual.CGPA}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Language Details
                </div>
                <div class="card-body p-1">
                    <div class="row m-1"
                        [ngClass]="{'bghighlight': EmployeeDetail.AdditionalInformation.Ess_Lang.length>0,'bghighlightworning': EmployeeDetail.AdditionalInformation.Ess_Lang.length == 0}">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col" style="background-color: lightgray;">#</th>
                                    <th scope="col" style="background-color: lightgray;">Language</th>
                                    <th scope="col" style="background-color: lightgray; ">Read</th>
                                    <th scope="col" style="background-color: lightgray;">Speak</th>
                                    <th scope="col" style="background-color: lightgray;">Write</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="let Ess_Lang of EmployeeDetail.AdditionalInformation.Ess_Lang; let i = index">
                                    <th scope="row">{{ i + 1 }}</th>
                                    <td>{{ Ess_Lang.Language }}</td>
                                    <td>
                                        <input class="form-check-input" type="checkbox" name="ChkRead{{i}}"
                                            id="ChkRead{{i}}" [(ngModel)]="Ess_Lang.Read" disabled>
                                    </td>
                                    <td>
                                        <input class="form-check-input" type="checkbox" name="ChkSpeak{{i}}"
                                            id="ChkSpeak{{i}}" [(ngModel)]="Ess_Lang.Speak" disabled>
                                    </td>
                                    <td>
                                        <input class="form-check-input" type="checkbox" name="ChkWrite{{i}}"
                                            id="ChkWrite{{i}}" [(ngModel)]="Ess_Lang.Write" disabled>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            Local Address
                        </div>
                        <div class="col-auto"
                            *ngIf="EmployeeDetail.AddressTab.Attachment != '' && EmployeeDetail.AddressTab.Attachment != null">
                            <a [href]="EmployeeDetail.AddressTab.Attachmenturl" target="_blank">
                                <span class="badge verify success">
                                    <i class="bi bi-paperclip"></i> View
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="card-body p-1">
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.LocalAddress[0].LocalAddress1!=null,'bghighlightworning': EmployeeDetail.AddressTab.LocalAddress[0].LocalAddress1==null}">
                            <div class="row">
                                <div class="text-label">Address 1</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.LocalAddress[0].LocalAddress1}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.LocalAddress[0].LocalAddress2!=null,'bghighlightworning': EmployeeDetail.AddressTab.LocalAddress[0].LocalAddress2==null}">
                            <div class="row">
                                <div class="text-label">Address 2</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.LocalAddress[0].LocalAddress2}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.LocalAddress[0].StateName!=null,'bghighlightworning': EmployeeDetail.AddressTab.LocalAddress[0].StateName==null}">
                            <div class="row">
                                <div class="text-label">State</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.LocalAddress[0].StateName}}</div>
                            </div>
                        </div>

                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.LocalAddress[0].DistrictName!=null,'bghighlightworning': EmployeeDetail.AddressTab.LocalAddress[0].DistrictName==null}">
                            <div class="row">
                                <div class="text-label">District</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.LocalAddress[0].DistrictName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.LocalAddress[0].LocalCity!=null,'bghighlightworning': EmployeeDetail.AddressTab.LocalAddress[0].LocalCity==null}">
                            <div class="row">
                                <div class="text-label">City</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.LocalAddress[0].LocalCity}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.LocalAddress[0].TalukaName!=null,'bghighlightworning': EmployeeDetail.AddressTab.LocalAddress[0].TalukaName==null}">
                            <div class="row">
                                <div class="text-label">Taluka</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.LocalAddress[0].TalukaName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.LocalAddress[0].LocalPincode!=null,'bghighlightworning': EmployeeDetail.AddressTab.LocalAddress[0].LocalPincode==null}">
                            <div class="row">
                                <div class="text-label">Pincode</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.LocalAddress[0].LocalPincode}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.LocalAddress[0].LocalPoliceStation!=null,'bghighlightworning': EmployeeDetail.AddressTab.LocalAddress[0].LocalPoliceStation==null}">
                            <div class="row">
                                <div class="text-label">Police Station</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.LocalAddress[0].LocalPoliceStation}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.LocalAddress[0].LocalPostOffice!=null,'bghighlightworning': EmployeeDetail.AddressTab.LocalAddress[0].LocalPostOffice==null}">
                            <div class="row">
                                <div class="text-label">Post Office</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.LocalAddress[0].LocalPostOffice}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.LocalAddress[0].LocalDateResiding!=null,'bghighlightworning': EmployeeDetail.AddressTab.LocalAddress[0].LocalDateResiding==null}">
                            <div class="row">
                                <div class="text-label">Residing Since</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.LocalAddress[0].LocalDateResiding}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Property Owned</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.LocalAddress[0].LocalPropertyOwned?'Yes':'No'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Native Address
                </div>
                <div class="card-body p-1">
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.NativeAddress[0].NativeAddress1!=null,'bghighlightworning': EmployeeDetail.AddressTab.NativeAddress[0].NativeAddress1==null}">
                            <div class="row">
                                <div class="text-label">Address 1</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.NativeAddress[0].NativeAddress1}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.NativeAddress[0].NativeAddress2!=null,'bghighlightworning': EmployeeDetail.AddressTab.NativeAddress[0].NativeAddress2==null}">
                            <div class="row">
                                <div class="text-label">Address 2</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.NativeAddress[0].NativeAddress2}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.NativeAddress[0].StateName!=null,'bghighlightworning': EmployeeDetail.AddressTab.NativeAddress[0].StateName==null}">
                            <div class="row">
                                <div class="text-label">State</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.NativeAddress[0].StateName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.NativeAddress[0].DistrictName!=null,'bghighlightworning': EmployeeDetail.AddressTab.NativeAddress[0].DistrictName==null}">
                            <div class="row">
                                <div class="text-label">District</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.NativeAddress[0].DistrictName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.NativeAddress[0].NativeCity!=null,'bghighlightworning': EmployeeDetail.AddressTab.NativeAddress[0].NativeCity==null}">
                            <div class="row">
                                <div class="text-label">City</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.NativeAddress[0].NativeCity}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.NativeAddress[0].TalukaName!=null,'bghighlightworning': EmployeeDetail.AddressTab.NativeAddress[0].TalukaName==null}">
                            <div class="row">
                                <div class="text-label">Taluka</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.NativeAddress[0].TalukaName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.NativeAddress[0].NativePincode!=null,'bghighlightworning': EmployeeDetail.AddressTab.NativeAddress[0].NativePincode==null}">
                            <div class="row">
                                <div class="text-label">Pincode</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.NativeAddress[0].NativePincode}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.NativeAddress[0].NativePoliceStation!=null,'bghighlightworning': EmployeeDetail.AddressTab.NativeAddress[0].NativePoliceStation==null}">
                            <div class="row">
                                <div class="text-label">Police Station</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.NativeAddress[0].NativePoliceStation}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.NativeAddress[0].NativePostOffice!=null,'bghighlightworning': EmployeeDetail.AddressTab.NativeAddress[0].NativePostOffice==null}">
                            <div class="row">
                                <div class="text-label">Post Office</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.NativeAddress[0].NativePostOffice}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.NativeAddress[0].NativeContactPersonName!=null,'bghighlightworning': EmployeeDetail.AddressTab.NativeAddress[0].NativeContactPersonName==null}">
                            <div class="row">
                                <div class="text-label">Contact Person Name</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.NativeAddress[0].NativeContactPersonName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.NativeAddress[0].NativeContactPersonNo!=null,'bghighlightworning': EmployeeDetail.AddressTab.NativeAddress[0].NativeContactPersonNo==null}">
                            <div class="row">
                                <div class="text-label">Contact Person No</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.NativeAddress[0].NativeContactPersonNo}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Place of Birth
                </div>
                <div class="card-body p-1">
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress1!=null,'bghighlightworning': EmployeeDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress1==null}">
                            <div class="row">
                                <div class="text-label">Address 1</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress1}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress2!=null,'bghighlightworning': EmployeeDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress2==null}">
                            <div class="row">
                                <div class="text-label">Address 2</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress2}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.PlaceofBirth[0].StateName!=null,'bghighlightworning': EmployeeDetail.AddressTab.PlaceofBirth[0].StateName==null}">
                            <div class="row">
                                <div class="text-label">State</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.PlaceofBirth[0].StateName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.PlaceofBirth[0].DistrictName!=null,'bghighlightworning': EmployeeDetail.AddressTab.PlaceofBirth[0].DistrictName==null}">
                            <div class="row">
                                <div class="text-label">District</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.PlaceofBirth[0].DistrictName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthCity!=null,'bghighlightworning': EmployeeDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthCity==null}">
                            <div class="row">
                                <div class="text-label">City</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthCity}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.PlaceofBirth[0].TalukaName!=null,'bghighlightworning': EmployeeDetail.AddressTab.PlaceofBirth[0].TalukaName==null}">
                            <div class="row">
                                <div class="text-label">Taluka</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.PlaceofBirth[0].TalukaName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthPincode!=null,'bghighlightworning': EmployeeDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthPincode==null}">
                            <div class="row">
                                <div class="text-label">Pincode</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthPincode}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Emergency Contact
                </div>
                <div class="card-body p-1">
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.EmergencyContact[0].ContactName!=null,'bghighlightworning': EmployeeDetail.AddressTab.EmergencyContact[0].ContactName==null}">
                            <div class="row">
                                <div class="text-label">Contact Name</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.EmergencyContact[0].ContactName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.EmergencyContact[0].ContactNumber!=null,'bghighlightworning': EmployeeDetail.AddressTab.EmergencyContact[0].ContactNumber==null}">
                            <div class="row">
                                <div class="text-label">Contact Number</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.EmergencyContact[0].ContactNumber}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.EmergencyContactStateDetails[0].RelationshipName!=null,'bghighlightworning': EmployeeDetail.AddressTab.EmergencyContactStateDetails[0].RelationshipName==null}">
                            <div class="row">
                                <div class="text-label">Relationship</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.EmergencyContactStateDetails[0].RelationshipName??''}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.EmergencyContact[0].ContactAddress1!=null,'bghighlightworning': EmployeeDetail.AddressTab.EmergencyContact[0].ContactAddress1==null}">
                            <div class="row">
                                <div class="text-label">Address 1</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.EmergencyContact[0].ContactAddress1}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.EmergencyContact[0].ContactAddress2!=null,'bghighlightworning': EmployeeDetail.AddressTab.EmergencyContact[0].ContactAddress2==null}">
                            <div class="row">
                                <div class="text-label">Address 2</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.EmergencyContact[0].ContactAddress2}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.EmergencyContactStateDetails[0].StateName!=null,'bghighlightworning': EmployeeDetail.AddressTab.EmergencyContactStateDetails[0].StateName==null}">
                            <div class="row">
                                <div class="text-label">State</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.EmergencyContactStateDetails[0].StateName??''}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.EmergencyContactStateDetails[0].DistrictName!=null,'bghighlightworning': EmployeeDetail.AddressTab.EmergencyContactStateDetails[0].DistrictName==null}">
                            <div class="row">
                                <div class="text-label">District</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.EmergencyContactStateDetails[0].DistrictName??''}}
                                </div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.EmergencyContact[0].ContactCity!=null,'bghighlightworning': EmployeeDetail.AddressTab.EmergencyContact[0].ContactCity==null}">
                            <div class="row">
                                <div class="text-label">City</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.EmergencyContact[0].ContactCity}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.EmergencyContactStateDetails[0].TalukaName!=null,'bghighlightworning': EmployeeDetail.AddressTab.EmergencyContactStateDetails[0].TalukaName==null}">
                            <div class="row">
                                <div class="text-label">Taluka</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.EmergencyContactStateDetails[0].TalukaName??''}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AddressTab.EmergencyContact[0].Pincode!=null,'bghighlightworning': EmployeeDetail.AddressTab.EmergencyContact[0].Pincode==null}">
                            <div class="row">
                                <div class="text-label">Pincode</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AddressTab.EmergencyContact[0].Pincode}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    PF Nominee Details
                </div>
                <div class="card-body p-1">
                    <div *ngFor="let EmpPFNomineeDetail of EmployeeDetail.EmpNomineeESIC.EmpPFNomineeDetails; let i = index"
                        class="card mt-1">
                        <div class="card-header">
                            <div class="row">
                                <div class="col">
                                    <div class="card-subtitle">PF Nominee - {{i + 1}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpPFNomineeDetail.EmpPFNominee!=null,'bghighlightworning': EmpPFNomineeDetail.EmpPFNominee==null}">
                                    <div class="row">
                                        <div class="text-label">Nominee</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpPFNomineeDetail.EmpPFNominee}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpPFNomineeDetail.RelationshipName!=null,'bghighlightworning': EmpPFNomineeDetail.RelationshipName==null}">
                                    <div class="row">
                                        <div class="text-label">Relationship</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpPFNomineeDetail.RelationshipName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpPFNomineeDetail.NomineeBirthDate!=null,'bghighlightworning': EmpPFNomineeDetail.NomineeBirthDate==null}">
                                    <div class="row">
                                        <div class="text-label">Birth Date</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpPFNomineeDetail.NomineeBirthDate}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpPFNomineeDetail.NomineeShare!=null,'bghighlightworning': EmpPFNomineeDetail.NomineeShare==null}">
                                    <div class="row">
                                        <div class="text-label">Share %</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpPFNomineeDetail.NomineeShare}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpPFNomineeDetail.NomineeAddress1!=null,'bghighlightworning': EmpPFNomineeDetail.NomineeAddress1==null}">
                                    <div class="row">
                                        <div class="text-label">Address 1</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpPFNomineeDetail.NomineeAddress1}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpPFNomineeDetail.NomineeAddress2!=null,'bghighlightworning': EmpPFNomineeDetail.NomineeAddress2==null}">
                                    <div class="row">
                                        <div class="text-label">Address 2</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpPFNomineeDetail.NomineeAddress2}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpPFNomineeDetail.StateName!=null,'bghighlightworning': EmpPFNomineeDetail.StateName==null}">
                                    <div class="row">
                                        <div class="text-label">State</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpPFNomineeDetail.StateName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpPFNomineeDetail.DistrictName!=null,'bghighlightworning': EmpPFNomineeDetail.DistrictName==null}">
                                    <div class="row">
                                        <div class="text-label">District</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpPFNomineeDetail.DistrictName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpPFNomineeDetail.NomineeVillageCity!=null,'bghighlightworning': EmpPFNomineeDetail.NomineeVillageCity==null}">
                                    <div class="row">
                                        <div class="text-label">City</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpPFNomineeDetail.NomineeVillageCity}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpPFNomineeDetail.TalukaName!=null,'bghighlightworning': EmpPFNomineeDetail.TalukaName==null}">
                                    <div class="row">
                                        <div class="text-label">Taluka</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpPFNomineeDetail.TalukaName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpPFNomineeDetail.NomineePinCode!=null,'bghighlightworning': EmpPFNomineeDetail.NomineePinCode==null}">
                                    <div class="row">
                                        <div class="text-label">Pincode</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpPFNomineeDetail.NomineePinCode}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpPFNomineeDetail.ContactNo!=null,'bghighlightworning': EmpPFNomineeDetail.ContactNo==null}">
                                    <div class="row">
                                        <div class="text-label">Contact No</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpPFNomineeDetail.ContactNo}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpPFNomineeDetail.Minor!=null,'bghighlightworning': EmpPFNomineeDetail.Minor==null}">
                                    <div class="row">
                                        <div class="text-label">Minor</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpPFNomineeDetail.Minor}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpPFNomineeDetail.MinorNomineeGuardian!=null,'bghighlightworning': EmpPFNomineeDetail.MinorNomineeGuardian==null}">
                                    <div class="row">
                                        <div class="text-label">Guardian</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpPFNomineeDetail.MinorNomineeGuardian}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpPFNomineeDetail.AddressType!=null,'bghighlightworning': EmpPFNomineeDetail.AddressType==null}">
                                    <div class="row">
                                        <div class="text-label">Address Type</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpPFNomineeDetail.AddressType}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    ESIC Nominee Details
                </div>
                <div class="card-body p-1">
                    <div *ngFor="let EmpDependentDetail of EmployeeDetail.EmpNomineeESIC.EmpDependentDetails; let i = index"
                        class="card mt-1">
                        <div class="card-header">
                            <div class="row">
                                <div class="col">
                                    ESIC Nominee - {{i + 1}}
                                </div>
                                <div class="col-auto"
                                    *ngIf="EmpDependentDetail.DocumentAttachment != '' && EmpDependentDetail.DocumentAttachment != null">
                                    <a [href]="EmpDependentDetail.DocumentAttachmenturl" target="_blank">
                                        <span class="badge verify success">
                                            <i class="bi bi-paperclip"></i> View
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpDependentDetail.Name!=null,'bghighlightworning': EmpDependentDetail.Name==null}">
                                    <div class="row">
                                        <div class="text-label">Name</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpDependentDetail.Name}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpDependentDetail.RelationshipName!=null,'bghighlightworning': EmpDependentDetail.RelationshipName==null}">
                                    <div class="row">
                                        <div class="text-label">Relationship</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpDependentDetail.RelationshipName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpDependentDetail.DateOfBirth!=null,'bghighlightworning': EmpDependentDetail.DateOfBirth==null}">
                                    <div class="row">
                                        <div class="text-label">Date Of Birth</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpDependentDetail.DateOfBirth}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpDependentDetail.AddressTypeName!=null,'bghighlightworning': EmpDependentDetail.AddressTypeName==null}">
                                    <div class="row">
                                        <div class="text-label">Address Type</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmpDependentDetail.AddressTypeName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmpDependentDetail.DocumentNo!=null && EmpDependentDetail.DocumentNo!='' && EmpDependentDetail.DocumentNo!=0&& EmpDependentDetail.DocumentNo!='0','bghighlightworning': EmpDependentDetail.DocumentNo==null || EmpDependentDetail.DocumentNo=='' || EmpDependentDetail.DocumentNo==0 || EmpDependentDetail.DocumentNo=='0'}">
                                    <div class="row">
                                        <div class="text-label">{{EmpDependentDetail.DocumentName}}</div>
                                    </div>
                                    <div class="row text-right"
                                        *ngIf="EmpDependentDetail.DocumentNo!=null && EmpDependentDetail.DocumentNo!='' && EmpDependentDetail.DocumentNo!=0&& EmpDependentDetail.DocumentNo!='0'">
                                        <div>{{EmpDependentDetail.DocumentNo}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Referral
                </div>
                <div class="card-body p-1">
                    <div *ngFor="let ReferenceDetail of EmployeeDetail.OtherDetails.Referraldetails; let i = index"
                        class="card mt-1">
                        <div class="card-header">
                            <div class="card-subtitle">Referral Details</div>
                        </div>
                        <div class="card-body">
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': ReferenceDetail.ReferralSource!=null,'bghighlightworning': ReferenceDetail.ReferralSource==null}">
                                    <div class="row">
                                        <div class="text-label">Referral</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{ReferenceDetail.ReferralSource}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': ReferenceDetail.ReferralSourceCategory!=null,'bghighlightworning': ReferenceDetail.ReferralSourceCategory==null}">
                                    <div class="row">
                                        <div class="text-label">Category</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{ReferenceDetail.ReferralSourceCategory}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': ReferenceDetail.ReferrerCode!=null,'bghighlightworning': ReferenceDetail.ReferrerCode==null}">
                                    <div class="row">
                                        <div class="text-label">Employee</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{ReferenceDetail.ReferrerCode}} - {{ReferenceDetail.ReferrerName}}</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Refrence Details
                </div>
                <div class="card-body p-1">
                    <div *ngFor="let ReferenceDetail of EmployeeDetail.OtherDetails.ReferenceDetails; let i = index"
                        class="card mt-1">
                        <div class="card-header">
                            <div class="card-subtitle">Reference - {{i + 1}}</div>
                        </div>
                        <div class="card-body">
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': ReferenceDetail.Name!=null,'bghighlightworning': ReferenceDetail.Name==null}">
                                    <div class="row">
                                        <div class="text-label">Name</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{ReferenceDetail.Name}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': ReferenceDetail.ContactNo!=null,'bghighlightworning': ReferenceDetail.ContactNo==null}">
                                    <div class="row">
                                        <div class="text-label">Contact No</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{ReferenceDetail.ContactNo}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': ReferenceDetail.Address1!=null,'bghighlightworning': ReferenceDetail.Address1==null}">
                                    <div class="row">
                                        <div class="text-label">Address 1</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{ReferenceDetail.Address1}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': ReferenceDetail.Address2!=null,'bghighlightworning': ReferenceDetail.Address2==null}">
                                    <div class="row">
                                        <div class="text-label">Address 2</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{ReferenceDetail.Address2}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': ReferenceDetail.StateName!=null,'bghighlightworning': ReferenceDetail.StateName==null}">
                                    <div class="row">
                                        <div class="text-label">State</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{ReferenceDetail.StateName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': ReferenceDetail.DistrictName!=null,'bghighlightworning': ReferenceDetail.DistrictName==null}">
                                    <div class="row">
                                        <div class="text-label">District</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{ReferenceDetail.DistrictName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': ReferenceDetail.VillageCity!=null,'bghighlightworning': ReferenceDetail.VillageCity==null}">
                                    <div class="row">
                                        <div class="text-label">City</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{ReferenceDetail.VillageCity}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': ReferenceDetail.TalukaName!=null,'bghighlightworning': ReferenceDetail.TalukaName==null}">
                                    <div class="row">
                                        <div class="text-label">Taluka</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{ReferenceDetail.TalukaName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': ReferenceDetail.PinCode!=null,'bghighlightworning': ReferenceDetail.PinCode==null}">
                                    <div class="row">
                                        <div class="text-label">Pincode</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{ReferenceDetail.PinCode}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Witness Details
                </div>
                <div class="card-body p-1">
                    <div *ngFor="let WitnessDetail of EmployeeDetail.OtherDetails.Witness; let i = index"
                        class="card mt-1">
                        <div class="card-header">
                            <div class="card-subtitle">Witness - {{i + 1}}</div>
                        </div>
                        <div class="card-body">
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': WitnessDetail.Name!=null,'bghighlightworning': WitnessDetail.Name==null}">
                                    <div class="row">
                                        <div class="text-label">Name</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{WitnessDetail.Name}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': WitnessDetail.ContactNo!=null,'bghighlightworning': WitnessDetail.ContactNo==null}">
                                    <div class="row">
                                        <div class="text-label">Contact No</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{WitnessDetail.ContactNo}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': WitnessDetail.Address1!=null,'bghighlightworning': WitnessDetail.Address1==null}">
                                    <div class="row">
                                        <div class="text-label">Address 1</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{WitnessDetail.Address1}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': WitnessDetail.Address2!=null,'bghighlightworning': WitnessDetail.Address2==null}">
                                    <div class="row">
                                        <div class="text-label">Address 2</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{WitnessDetail.Address2}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': WitnessDetail.StateName!=null,'bghighlightworning': WitnessDetail.StateName==null}">
                                    <div class="row">
                                        <div class="text-label">State</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{WitnessDetail.StateName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': WitnessDetail.DistrictName!=null,'bghighlightworning': WitnessDetail.DistrictName==null}">
                                    <div class="row">
                                        <div class="text-label">District</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{WitnessDetail.DistrictName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': WitnessDetail.VillageCity!=null,'bghighlightworning': WitnessDetail.VillageCity==null}">
                                    <div class="row">
                                        <div class="text-label">City</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{WitnessDetail.VillageCity}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': WitnessDetail.TalukaName!=null,'bghighlightworning': WitnessDetail.TalukaName==null}">
                                    <div class="row">
                                        <div class="text-label">Taluka</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{WitnessDetail.TalukaName}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': WitnessDetail.PinCode!=null,'bghighlightworning': WitnessDetail.PinCode==null}">
                                    <div class="row">
                                        <div class="text-label">Pincode</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{WitnessDetail.PinCode}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Previous Employment Details
                </div>
                <div class="card-body p-1">
                    <div *ngFor="let EmploymentDetail of EmployeeDetail.OtherDetails.PreviousEmploymentdetails; let i = index"
                        class="card mt-1">
                        <div class="card-header">
                            <div class="row">
                                <div class="col">
                                    <div class="card-subtitle">Employment - {{i + 1}}</div>
                                </div>
                                <div class="col-auto"
                                    *ngIf="EmploymentDetail.RelievingLetter != '' && EmploymentDetail.RelievingLetter != null">
                                    <a [href]="EmploymentDetail.RelievingLetterurl" target="_blank">
                                        <span class="badge verify success">
                                            <i class="bi bi-paperclip"></i> Relieving Letter
                                        </span>
                                    </a>
                                </div>
                                <div class="col-auto"
                                    *ngIf="EmploymentDetail.OfferLetter != '' && EmploymentDetail.OfferLetter != null">
                                    <a [href]="EmploymentDetail.OfferLetterurl" target="_blank">
                                        <span class="badge verify success">
                                            <i class="bi bi-paperclip"></i> Offer Letter
                                        </span>
                                    </a>
                                </div>
                                <div class="col-auto"
                                    *ngIf="EmploymentDetail.Payslip != '' && EmploymentDetail.Payslip != null">
                                    <a [href]="EmploymentDetail.Payslipurl" target="_blank">
                                        <span class="badge verify success">
                                            <i class="bi bi-paperclip"></i> Payslip
                                        </span>
                                    </a>
                                </div>
                                <div class="col-auto"
                                    *ngIf="EmploymentDetail.Attachment != '' && EmploymentDetail.Attachment != null">
                                    <a [href]="EmploymentDetail.Attachmenturl" target="_blank">
                                        <span class="badge verify success">
                                            <i class="bi bi-paperclip"></i> View
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmploymentDetail.Name!=null,'bghighlightworning': EmploymentDetail.Name==null}">
                                    <div class="row">
                                        <div class="text-label">Name</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmploymentDetail.Name}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmploymentDetail.Address!=null,'bghighlightworning': EmploymentDetail.Address==null}">
                                    <div class="row">
                                        <div class="text-label">Address</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmploymentDetail.Address}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmploymentDetail.Position!=null,'bghighlightworning': EmploymentDetail.Position==null}">
                                    <div class="row">
                                        <div class="text-label">Position</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmploymentDetail.Position}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmploymentDetail.FromDate!=null,'bghighlightworning': EmploymentDetail.FromDate==null}">
                                    <div class="row">
                                        <div class="text-label">From Date</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmploymentDetail.FromDate}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmploymentDetail.ToDate!=null,'bghighlightworning': EmploymentDetail.ToDate==null}">
                                    <div class="row">
                                        <div class="text-label">To Date</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmploymentDetail.ToDate}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmploymentDetail.EmployerPFNo!=null,'bghighlightworning': EmploymentDetail.EmployerPFNo==null}">
                                    <div class="row">
                                        <div class="text-label">Employer PFNo</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmploymentDetail.EmployerPFNo}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmploymentDetail.EmployerESICNo!=null,'bghighlightworning': EmploymentDetail.EmployerESICNo==null}">
                                    <div class="row">
                                        <div class="text-label">Employer ESICNo</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmploymentDetail.EmployerESICNo}}</div>
                                    </div>
                                </div>
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmploymentDetail.TotalSalaryDrawn!=null,'bghighlightworning': EmploymentDetail.TotalSalaryDrawn==null}">
                                    <div class="row">
                                        <div class="text-label">Total Salary Drawn</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmploymentDetail.TotalSalaryDrawn}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md mx-1 px-1"
                                    [ngClass]="{'bghighlight': EmploymentDetail.ReasonOfLeaving!=null,'bghighlightworning': EmploymentDetail.ReasonOfLeaving==null}">
                                    <div class="row">
                                        <div class="text-label">Reason Of Leaving</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{EmploymentDetail.ReasonOfLeaving}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Accounts And Licences
                </div>
                <div class="card-body p-1">
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Existing Member Of ESIC</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.ExistingMemberOfESIC?'Yes':'No'}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.ESICNo!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.ESICNo==null}">
                            <div class="row">
                                <div class="text-label">ESIC No</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.ESICNo}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Existing Member Of PF</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.ExistingMemberOfPF?'Yes':'No'}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.PFNo!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.PFNo==null}">
                            <div class="row">
                                <div class="text-label">PF No</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.PFNo}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">PF Statutory Deduction</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.PFStatutoryDeduction?'Yes':'No'}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.UANNo!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.UANNo==null}">
                            <div class="row">
                                <div class="text-label">UANNo</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.UANNo}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.LINNo!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.LINNo==null}">
                            <div class="row">
                                <div class="text-label">LINNo</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.LINNo}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.HoldingGun!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.HoldingGun==null}">
                            <div class="row">
                                <div class="text-label">Holding Gun</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.HoldingGun}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.TypeofGunName!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.TypeofGunName==null}">
                            <div class="row">
                                <div class="text-label">Type of Gun</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.TypeofGunName}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.GunNo!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.GunNo==null}">
                            <div class="row">
                                <div class="text-label">GunNo</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.GunNo}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.GunLicenseNo!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.GunLicenseNo==null}">
                            <div class="row">
                                <div class="text-label">Gun LicenceNo</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.GunLicenseNo}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.IssuingAuthority!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.IssuingAuthority==null}">
                            <div class="row">
                                <div class="text-label">Issuing Authority</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.IssuingAuthority}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.DateOfIssue!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.DateOfIssue==null}">
                            <div class="row">
                                <div class="text-label">Date Of Issue</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.DateOfIssue}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.DateOfExpiry!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.DateOfExpiry==null}">
                            <div class="row">
                                <div class="text-label">Date Of Expiry</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.DateOfExpiry}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.GunRegistrationDate!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.GunRegistrationDate==null}">
                            <div class="row">
                                <div class="text-label">Registration Date</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.GunRegistrationDate}}</div>
                            </div>
                        </div>
                        <div class="col-md-1 mx-1 px-1" *ngIf="EmployeeDetail.AccountLicencesTab.GunAttachment">
                            <a [href]="EmployeeDetail.AccountLicencesTab.GunAttachmenturl" target="_blank">
                                <span class="badge verify success">
                                    <i class="bi bi-paperclip"></i> View
                                </span>
                            </a>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.HoldingDrivingLicense!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.HoldingDrivingLicense==null}">
                            <div class="row">
                                <div class="text-label">Holding Driving Licence</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.HoldingDrivingLicense}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.DrivingLicenseNumber!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.DrivingLicenseNumber==null}">
                            <div class="row">
                                <div class="text-label">Driving Licence Number</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.DrivingLicenseNumber}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.DrivingLicenseIssueDate!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.DrivingLicenseIssueDate==null}">
                            <div class="row">
                                <div class="text-label">Driving Licence Issue Date</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.DrivingLicenseIssueDate}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.DrivingLicenseExpiryDate!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.DrivingLicenseExpiryDate==null}">
                            <div class="row">
                                <div class="text-label">Driving Licence Expiry Date</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.DrivingLicenseExpiryDate}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.AccountLicencesTab.DrivingLicenseIssuingAuthority!=null,'bghighlightworning': EmployeeDetail.AccountLicencesTab.DrivingLicenseIssuingAuthority==null}">
                            <div class="row">
                                <div class="text-label">Driving Licence Issuing Authority</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.AccountLicencesTab.DrivingLicenseIssuingAuthority}}</div>
                            </div>
                        </div>
                        <div class="col-md-1 mx-1 px-1" *ngIf="EmployeeDetail.AccountLicencesTab.DrivingAttachment">
                            <a [href]="EmployeeDetail.AccountLicencesTab.DrivingAttachmenturl" target="_blank">
                                <span class="badge verify success">
                                    <i class="bi bi-paperclip"></i> View
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Image & Document
                </div>
                <div class="card-body p-1">
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.ImageDocumnetTab.InterviewingOfficer!=null,'bghighlightworning': EmployeeDetail.ImageDocumnetTab.InterviewingOfficer==null}">
                            <div class="row">
                                <div class="text-label">Interviewing Officer</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.ImageDocumnetTab.InterviewingOfficer}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.ImageDocumnetTab.AppointingAuthority!=null,'bghighlightworning': EmployeeDetail.ImageDocumnetTab.AppointingAuthority==null}">
                            <div class="row">
                                <div class="text-label">Appointing Authority</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.ImageDocumnetTab.AppointingAuthority}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.ImageDocumnetTab.RecommendedBy1!=null,'bghighlightworning': EmployeeDetail.ImageDocumnetTab.RecommendedBy1==null}">
                            <div class="row">
                                <div class="text-label">Recommended By 1</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.ImageDocumnetTab.RecommendedBy1}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.ImageDocumnetTab.RecommendedBy2!=null,'bghighlightworning': EmployeeDetail.ImageDocumnetTab.RecommendedBy2==null}">
                            <div class="row">
                                <div class="text-label">Recommended By 2</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.ImageDocumnetTab.RecommendedBy2}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md mx-1 px-1"
                            [ngClass]="{'bghighlight': EmployeeDetail.ImageDocumnetTab.Remark!=null,'bghighlightworning': EmployeeDetail.ImageDocumnetTab.Remark==null}">
                            <div class="row">
                                <div class="text-label">Remark</div>
                            </div>
                            <div class="row text-right">
                                <div>{{EmployeeDetail.ImageDocumnetTab.Remark}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Photo & Signature
                </div>
                <div class="card-body p-1">
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">Photo</label><br />
                            <img *ngIf="EmployeeDetail.ImageDocumnetTab.Photo" mat-card-image class="registrationImage"
                                height="70%" width="70%" [src]="EmployeeDetail.ImageDocumnetTab.Photourl">
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Signature</label><br />
                            <img *ngIf="EmployeeDetail.ImageDocumnetTab.Signature" mat-card-image
                                class="registrationImage" height="50%" width="50%"
                                [src]="EmployeeDetail.ImageDocumnetTab.Signatureurl">
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Left Hand Impression
                </div>
                <div class="card-body p-1">
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">Thumb</label><br />
                            <img mat-card-image *ngIf="EmployeeDetail.ImageDocumnetTab.LH1" class="registrationImage"
                                height="60%" width="60%" [src]="EmployeeDetail.ImageDocumnetTab.LH1url">
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">Finger 1</label><br />
                            <img mat-card-image *ngIf="EmployeeDetail.ImageDocumnetTab.LH2" class="registrationImage"
                                height="50%" width="50%" [src]="EmployeeDetail.ImageDocumnetTab.LH2url">
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">Finger 2</label><br />
                            <img mat-card-image *ngIf="EmployeeDetail.ImageDocumnetTab.LH3" class="registrationImage"
                                height="50%" width="50%" [src]="EmployeeDetail.ImageDocumnetTab.LH3url">
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">Finger 3</label><br />
                            <img mat-card-image *ngIf="EmployeeDetail.ImageDocumnetTab.LH4" class="registrationImage"
                                height="50%" width="50%" [src]="EmployeeDetail.ImageDocumnetTab.LH4url">
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">Finger 4</label><br />
                            <img mat-card-image *ngIf="EmployeeDetail.ImageDocumnetTab.LH5" class="registrationImage"
                                height="50%" width="50%" [src]="EmployeeDetail.ImageDocumnetTab.LH5url">
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Right Hand Impression
                </div>
                <div class="card-body p-1">
                    <div class="row m-1">
                        <div class="col-md-3 px-1">
                            <label class="Label">Thumb</label><br />
                            <img mat-card-image *ngIf="EmployeeDetail.ImageDocumnetTab.RH1" class="registrationImage"
                                height="60%" width="60%" [src]="EmployeeDetail.ImageDocumnetTab.RH1url">
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">Finger 1</label><br />
                            <img mat-card-image *ngIf="EmployeeDetail.ImageDocumnetTab.RH2" class="registrationImage"
                                height="50%" width="50%" [src]="EmployeeDetail.ImageDocumnetTab.RH2url">
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">Finger 2</label><br />
                            <img mat-card-image *ngIf="EmployeeDetail.ImageDocumnetTab.RH3" class="registrationImage"
                                height="50%" width="50%" [src]="EmployeeDetail.ImageDocumnetTab.RH3url">
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">Finger 3</label><br />
                            <img mat-card-image *ngIf="EmployeeDetail.ImageDocumnetTab.RH4" class="registrationImage"
                                height="50%" width="50%" [src]="EmployeeDetail.ImageDocumnetTab.RH4url">
                        </div>
                        <div class="col-md-2 px-1">
                            <label class="Label">Finger 4</label><br />
                            <img mat-card-image *ngIf="EmployeeDetail.ImageDocumnetTab.RH5" class="registrationImage"
                                height="50%" width="50%" [src]="EmployeeDetail.ImageDocumnetTab.RH5url">
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Documents
                </div>
                <div class="card-body p-1">
                    <div class="row m-1">
                        <div class="col-md-3 p-1"
                            *ngFor="let EmpDocumentAttachment of EmployeeDetail.ImageDocumnetTab.EmpDocumentAttachment; let i = index">
                            <div class="card mt-1">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col">
                                            {{EmpDocumentAttachment.DocumentName}}
                                        </div>
                                        <div class="col-auto"
                                            *ngIf="EmpDocumentAttachment.Attachment != '' && EmpDocumentAttachment.Attachment != null">
                                            <a [href]="EmpDocumentAttachment.Attachmenturl" target="_blank">
                                                <span class="badge verify success">
                                                    <i class="bi bi-paperclip"></i> View
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row m-1 bghighlight">
                                        <div class="col-md mx-1 px-1">
                                            <div class="row">
                                                <div class="text-label">Document No</div>
                                            </div>
                                            <div class="row text-right">
                                                <div>{{EmpDocumentAttachment.DocumentNo}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row m-1 bghighlight">
                                        <div class="col-md mx-1 px-1">
                                            <div class="row">
                                                <div class="text-label">Issue Date</div>
                                            </div>
                                            <div class="row text-right">
                                                <div>{{EmpDocumentAttachment.IssueDate}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row m-1 bghighlight">
                                        <div class="col-md mx-1 px-1">
                                            <div class="row">
                                                <div class="text-label">Expiry Date</div>
                                            </div>
                                            <div class="row text-right">
                                                <div>{{EmpDocumentAttachment.ExpiryDate}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" *ngIf="!this.EmployeeDetail.BasicInformation.IsTempEmployee">
                <div class="card-header">
                    Letter Details
                </div>
                <div class="card-body p-1">
                    <div class="row m-1">
                        <div class="col-md-12 p-1" *ngFor="let letter of this.LetterData; let i = index">
                            <div class="card mt-1">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col">
                                            <span>{{letter['LetterName']}}</span>
                                        </div>
                                        <div class="col-auto">
                                            <span class="badge mx-2"
                                                [ngClass]="{'success': common.ToLowerCase(letter['EmployeeApprovalStatus']) == 'approved', 'danger':common.ToLowerCase(letter['EmployeeApprovalStatus']) == 'rejected','warning':common.ToLowerCase(letter['EmployeeApprovalStatus']) == 'pending'}">{{letter['EmployeeApprovalStatus']}}</span>

                                            <a [href]="letter['LetterGenerationFileName']" target="_blank"
                                                *ngIf="letter['LetterGenerationFileName'] != '' && letter['LetterGenerationFileName'] != null">
                                                <span class="badge verify success">
                                                    <i class="bi bi-paperclip"></i> View
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row m-1">
                                        <div class="col-md mx-1 px-1 bghighlight">
                                            <div class="row">
                                                <div class="text-label">Letter Type</div>
                                            </div>
                                            <div class="row text-right">
                                                <div>{{letter['LetterDocumentTypeName']}}</div>
                                            </div>
                                        </div>
                                        <div class="col-md mx-1 px-1 bghighlight">
                                            <div class="row">
                                                <div class="text-label">Letter Name</div>
                                            </div>
                                            <div class="row text-right">
                                                <div>{{letter['LetterName']}}</div>
                                            </div>
                                        </div>
                                        <div class="col-md mx-1 px-1 bghighlight">
                                            <div class="row">
                                                <div class="text-label">Garneted Date</div>
                                            </div>
                                            <div class="row text-right">
                                                <div>{{letter['GenerationRequestDate']}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card"
                *ngIf="this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable && this.EmployeeDetail.employeeInfo.BGVStatus != '' && this.EmployeeDetail.employeeInfo.BGVStatus != 'null'">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            BGV History
                        </div>
                        <div class="col-auto">
                            <span class="badge" style="height: 21px; display: inline-flex;"
                                [ngStyle]="{ 'background':this.EmployeeDetail.employeeInfo.ColourCode}"
                                [style.color.!important]="EmployeeDetail.employeeInfo.FontColor">
                                <i style="font-size: 12px;"
                                    class="bi bi-{{common.ToLowerCase(this.EmployeeDetail.employeeInfo.BGVStatus) === 'clear' ? 'check-circle' : 'exclamation-circle'}}"></i>
                                BGV {{this.EmployeeDetail.employeeInfo.BGVStatus}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="card-body p-1">
                    <div class="verification-card mb-2"
                        *ngFor="let bgvHistoryHeaderData of bgvHistoryHeader; let i = index">
                        <div class="card-header">
                            <div class="row">
                                <div class="col">
                                    <div class="card-title">{{bgvHistoryHeaderData.APIName}} Verification
                                        <span class="badge success">{{bgvHistoryHeaderData.VerificationMode}}</span>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <div class="initiated-by">Created On {{bgvHistoryHeaderData.InitiatedOn}}
                                        <!-- By {{bgvHistoryHeaderData.InitiatedBy}} -->
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <span style="padding:3px;border-radius: 6px;"
                                        [ngStyle]="{ 'background':bgvHistoryHeaderData.FinalStatusColourCode,'color':bgvHistoryHeaderData.FinalStatusFontColor}"
                                        Class="status-bgv">{{bgvHistoryHeaderData.VerificationType}}</span>
                                </div>
                            </div>
                        </div>
                        <table class="verification-table">
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Status</th>
                                    <th>Details</th>
                                    <th>Initiated On</th>
                                    <th>Report</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let item of bgvHistoryHeaderData.Data; let j = index">
                                    <!-- Main Row -->
                                    <tr (click)="toggleRow(i,j)" [class.expanded-row]="item.expanded">
                                        <td>
                                            <span class="verification-type type-eav">
                                                {{ item.VerificationType }}
                                            </span>
                                        </td>
                                        <td>
                                            <span style="padding:3px;border-radius: 6px;place-self: anchor-center;"
                                                [ngStyle]="{ 'background':item.ColourCode,'color':item.FontColor}"
                                                Class="status-bgv">{{item.Verification_Status}}</span>
                                        </td>
                                        <td>
                                            <div>
                                                {{GetHedername(item.VerificationType)}}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {{item.InitiatedOn}}
                                            </div>
                                        </td>
                                        <td>
                                            <div class="action-buttons">
                                                <button class="btn btn-primary btn-sm me-2" type="button">
                                                    <span class="expand-indicator">▼</span> Details
                                                </button>
                                                <a [href]="item.ReportURL" target="_blanck" role="button"
                                                    class="btn btn-success btn-sm"
                                                    *ngIf="item.ReportURL != null && item.ReportURL != ''">
                                                    📊 Report
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="details-row" *ngIf="item.expanded">
                                        <td colspan="5" class="details-cell p-2">
                                            <div class="details-grid">
                                                <div class="detail-item">
                                                    <span class="detail-label">Verification Type</span>
                                                    <span class="detail-value">
                                                        {{GetHedername(item.VerificationType)}}
                                                    </span>
                                                </div>
                                                <div class="detail-item">
                                                    <span class="detail-label">Status</span>
                                                    <span style="padding:3px;border-radius: 6px;width: fit-content;"
                                                        [ngStyle]="{ 'background':item.ColourCode,'color':item.FontColor}"
                                                        class="status-bgv">{{item.Verification_Status}}</span>
                                                </div>
                                                <div class="detail-item">
                                                    <span class="detail-label">Initiated Date</span>
                                                    <span class="detail-value">{{item.InitiatedOn}}</span>
                                                </div>
                                                <div class="detail-item">
                                                    <span class="detail-label">Last Updated</span>
                                                    <span class="detail-value">{{item.ModifiedOn}}</span>
                                                </div>
                                                <div class="detail-item"
                                                    *ngIf="common.ToLowerCase(item.VerificationType)=='eav'">
                                                    <span class="detail-label">Address Detail</span>
                                                    <span class="detail-value">{{item.Address1}}</span>
                                                </div>
                                                <div class="detail-item"
                                                    *ngIf="common.ToLowerCase(item.VerificationType)=='crc'">
                                                    <span class="detail-label">Address Detail</span>
                                                    <span class="detail-value">{{item.LocalAddress1}}</span>
                                                </div>
                                                <div class="detail-item"
                                                    *ngIf="common.ToLowerCase(item.VerificationType)=='eqv'">
                                                    <span class="detail-label">College</span>
                                                    <span class="detail-value">{{item.College}}</span>
                                                </div>
                                                <div class="detail-item"
                                                    *ngIf="common.ToLowerCase(item.VerificationType)=='eqv'">
                                                    <span class="detail-label">Qualification</span>
                                                    <span class="detail-value">{{item.QualificationName}}</span>
                                                </div>
                                                <div class="detail-item"
                                                    *ngIf="common.ToLowerCase(item.VerificationType)=='eqv'">
                                                    <span class="detail-label">UniversityBoard</span>
                                                    <span class="detail-value">{{item.UniversityBoard}}</span>
                                                </div>
                                                <div class="detail-item"
                                                    *ngIf="common.ToLowerCase(item.VerificationType)=='eqv'">
                                                    <span class="detail-label">Enrollment No</span>
                                                    <span class="detail-value">{{item.EnrollmentNumber}}</span>
                                                </div>
                                                <div class="detail-item"
                                                    *ngIf="common.ToLowerCase(item.VerificationType)=='eqv'">
                                                    <span class="detail-label">CGPA</span>
                                                    <span class="detail-value">{{item.CGPA}}</span>
                                                </div>
                                                <div class="detail-item"
                                                    *ngIf="common.ToLowerCase(item.VerificationType)=='ev'">
                                                    <span class="detail-label">Previous Company Name</span>
                                                    <span class="detail-value">{{item.PrevCompanyName}}</span>
                                                </div>
                                                <div class="detail-item"
                                                    *ngIf="common.ToLowerCase(item.VerificationType)=='ev'">
                                                    <span class="detail-label">Previous Company Position</span>
                                                    <span class="detail-value">{{item.PrevCompanyPosition}}</span>
                                                </div>
                                                <div class="detail-item"
                                                    *ngIf="common.ToLowerCase(item.VerificationType)=='ev'">
                                                    <span class="detail-label">Joining Date</span>
                                                    <span class="detail-value">{{item.PrevCompanyJoiningDate}}</span>
                                                </div>
                                                <div class="detail-item"
                                                    *ngIf="common.ToLowerCase(item.VerificationType)=='ev'">
                                                    <span class="detail-label">Relieving Date</span>
                                                    <span class="detail-value">{{item.PrevCompanyRelievingDate}}</span>
                                                </div>
                                            </div>
                                            <div class="remarks">
                                                <div class="remarks-title">
                                                    <span>📝 Remarks</span>
                                                </div>
                                                <p>{{item.Status_Description}}</p>
                                                <p>{{item.Remarks}}</p>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col-auto me-2">
                    <img *ngIf="EmployeeDetail.BasicInformation.photo != null && EmployeeDetail.BasicInformation.photo != ''"
                        mat-card-image class="userImage" [src]="EmployeeDetail.BasicInformation.photourl" />
                    <div *ngIf="EmployeeDetail.BasicInformation.photo == null || EmployeeDetail.BasicInformation.photo == ''"
                        class="initial-image">
                        <div class="image">
                            {{common.getInitial(EmployeeDetail.employeeInfo.FirstName)}}
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="row">
                        <label class="text-label-dark">{{EmployeeDetail.employeeInfo.FirstName}}
                            <span class="badge"
                                [ngClass]="{'success': common.ToLowerCase(this.filter.EmpStatus) == 'approved', 'danger':common.ToLowerCase(this.filter.EmpStatus) == 'rejected','warning':common.ToLowerCase(this.filter.EmpStatus) == 'pending'}"
                                *ngIf="this.filter.EmpStatus != null && this.filter.EmpStatus != ''">
                                {{this.filter.EmpStatus}}
                            </span>
                        </label>
                    </div>
                    <div class="row">
                        <label class="text-label-dark">#{{EmployeeDetail.employeeInfo.EmpTempCode}}-
                            {{EmployeeDetail.employeeInfo.EmpType}}</label>
                    </div>
                </div>
                <div class="col">
                    <div class="row">
                        <div class="col-auto">
                            <div class="row">
                                <label class="text-label-dark"><i class="bi bi-envelope-fill pe-2"></i>
                                    <a
                                        href="mailto:{{EmployeeDetail.employeeInfo.EmailId}}">{{EmployeeDetail.employeeInfo.EmailIdShow}}</a></label>
                            </div>
                            <div class="row">
                                <label class="text-label-dark"><i class="bi bi-telephone-fill pe-2"></i>
                                    <a
                                        href="tel:{{EmployeeDetail.employeeInfo.MobileNo}}">{{EmployeeDetail.employeeInfo.MobileNoShow}}</a></label>
                            </div>
                        </div>
                        <div class="col-auto"><i class="bi bi" (click)="showFooterMasking()"
                                [ngClass]="{'bi-eye': !EmployeeDetail.employeeInfo.IsShow,'bi-eye-slash': EmployeeDetail.employeeInfo.IsShow}"></i>
                        </div>
                    </div>
                </div>
                <div class="col-auto"
                    *ngIf="this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable && this.EmployeeDetail.employeeInfo.BGVStatus != '' && this.EmployeeDetail.employeeInfo.BGVStatus != null">
                    <span class="badge" style="height: 21px; display: inline-flex;"
                        [ngStyle]="{ 'background':this.EmployeeDetail.employeeInfo.ColourCode}"
                        [style.color.!important]="EmployeeDetail.employeeInfo.FontColor">
                        <i style="font-size: 12px;"
                            class="bi bi-{{common.ToLowerCase(this.EmployeeDetail.employeeInfo.BGVStatus) === 'clear' ? 'check-circle' : 'exclamation-circle'}}"></i>
                        BGV {{this.EmployeeDetail.employeeInfo.BGVStatus}}
                    </span>
                </div>
                <div class="col-auto p-0"
                    *ngIf="!this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable || (this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable && (this.EmployeeDetail.employeeInfo.BGVStatus == '' || this.EmployeeDetail.employeeInfo.BGVStatus == null || this.common.ToLowerCase(this.EmployeeDetail.employeeInfo.VerificationMode) == 'manual'))">
                    <button type="button"
                        *ngIf="!user.IsPreOnBoarding && this.IsEditable && this.common.PageRight.IsEdit"
                        class="btn btn-sm btn-outline-primary me-1"
                        [routerLink]="['/'+this.addonURL1+'/'+this.addonURL2+'/add/' + filter.EmpMasterId + '/' + filter.IsDraft]"
                        name="btn2" [disabled]="isDisabled"><i class="bi bi-pencil-square" *ngIf="!isDisabled">
                        </i><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>{{!isDisabled?'
                        Edit':'Loading...'}}</button>

                    <button type="button"
                        *ngIf="user.IsPreOnBoarding && this.IsEditable && this.common.PageRight.IsEdit"
                        class="btn btn-sm btn-outline-primary me-1"
                        [routerLink]="['/preonboarding/add/' + filter.EmpMasterId + '/' + filter.IsDraft]" name="btn3"
                        [disabled]="isDisabled"><i class="bi bi-pencil-square" *ngIf="!isDisabled"> </i><span
                            class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>{{!isDisabled?'
                        Edit':'Loading...'}}</button>
                </div>
                <div class="col-auto p-0">
                    <button class="btn btn-sm btn-primary" name="btn1" [disabled]="isDisabled"
                        *ngIf="(!this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable || (this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable && (this.EmployeeDetail.employeeInfo.BGVStatus == '' || this.EmployeeDetail.employeeInfo.BGVStatus == null)))&&((!user.IsPreOnBoarding && this.filter.IsSendForApproval) || (filter.IsDraft && IsEditable && this.common.PageRight.IsEdit))"><i
                            class="bi bi-save" *ngIf="!isDisabled">
                        </i><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>{{!isDisabled?(this.common.ToLowerCase(this.addonURL2) ==
                        'mobileregister'?'Send for Approval':'Final Save'):'Loading...'}}</button>

                    <button type="button" class="btn btn-sm btn-primary" name="btn1" [disabled]="isDisabled"
                        *ngIf="(this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable && this.EmployeeDetail.employeeInfo.BGVStatus != null && this.EmployeeDetail.employeeInfo.BGVStatus != '' && this.common.ToLowerCase(this.EmployeeDetail.employeeInfo.BGVStatus) != 'clear') && ((!user.IsPreOnBoarding && this.filter.IsSendForApproval) || (filter.IsDraft && IsEditable && this.common.PageRight.IsEdit))"
                        (click)="this.EmployeeFinalSubmit(true)"><i
                            class="bi bi-save" *ngIf="!isDisabled">
                        </i><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>{{!isDisabled?'Bypass BGV':'Loading...'}}</button>

                    <button type="button" class="btn btn-sm btn-primary ms-1" [disabled]="isDisabled" (click)="Cancel()"
                        *ngIf="!this.user.IsPreOnBoarding"><i class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Cancel':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
</form>